import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ReactToPrint from "react-to-print";
import {
  getInvoiceItem,
  getServices,
  getSpecificInvoice,
} from "../../actions/invoiceItem";
import { getInvoiceMeasurement } from "../../actions/measurment";
import { getBusinessProfile } from "../../actions/settings";
import { getSpecificLocation } from "../../actions/warehouseAction";
import moment from "moment";
import Barcode from "react-barcode";

import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Button,
  Col,
  Row,
  Select,
  message,
  TreeSelect,
  Space,
  Divider,
  Drawer,
  Image,
  Skeleton,
} from "antd";

const { Option } = Select;

const Quickview = ({
  details,
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  businessprofile,
  getInvoiceMeasurement,
  getSpecificLocation,
  getSpecificInvoice,
  buttonType,
  disabled,
  buttonText,
  onAfterPrint,
  inline,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [visible, setVisible] = useState(false);
  const [loading, setloading] = useState(true);
  const [data, setdata] = useState([]);
  const [measurements, setmeasurements] = useState([]);
  const [branch, setbranch] = useState([]);
  const [services, setservices] = useState([]);
  const count = useRef(0);
  const serialcount = useRef(0);
  const formattedCreatedDate = (details && details.created_at) ? moment(details.created_at).format("DD-MM-YYYY HH:mm:ss") : "";
  const displayLocationName = (details && details.Location_name) === "Main Warehouse" ? "Facebook Page" : (details ? details.Location_name : "");

  const getWarehouseAbbr = (name) => {
    const map = {
      "Main Warehouse": "MW",
      "Shirtex - MB": "MB",
      "Shirtex - Elephant Road": "ER",
    };
    return map[name] || name.split(" ").map((w) => w[0]).join("").toUpperCase();
  };

  const fetchData = () => {
    getSpecificInvoice(details.id).then((result) => {
      console.log(result);
    });
    getSpecificLocation(details.location).then((result) => {
      setbranch(result);
    });
    getInvoiceItem(details.id).then((e) => {
      getBusinessProfile();
      getServices(details.id).then((service) => {
        getInvoiceMeasurement(details.id).then((result) => {
          if (result.length > 0) {
            setmeasurements(result[0]);
          } else {
            setmeasurements(false);
          }
          count.current = e.length + service.length;
          if (count.current < 10) count.current = 10 - count.current;
          else {
            count.current = 0;
          }
          setdata([...e, ...service]);

          setloading(false);
          setservices(service);
        });
      });
    });
  };

  useEffect(() => {
    if (inline && details) {
      fetchData();
    }
  }, [inline, details]);

  const showDrawer = () => {
    fetchData();
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };
  const renderImage = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <img
          src={businessprofile.logo}
          style={{
            width: "40%",
            right: "0",
          }}
        />
      );
    }
  };
  const renderitems = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return data.map((item, index) => {
        console.log(item);
        serialcount.current = index + 1;
        return (
          <>
            <tr>
              <td>{index + 1}</td>
              {item.details ? (
                <td>
                  {" "}
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{ __html: item.Product[0].Deatils[0].product_code }}
                  ></div>-- {item.Product[0].Deatils[0].title} -- {item.Product[0].Attribute_details} {details.Location_name === "Ecommerce" && <span style={{ fontWeight: "800" }}>({getWarehouseAbbr(item.Product[0].Warehouse_name)})</span>}
                </td>
              ) : (
                <td>{item.Product[0].Deatils[0].product_code} -- {item.Product[0].Deatils[0].title} -- {item.Product[0].Attribute_details} {details.Location_name === "Ecommerce" && <span style={{ fontWeight: "800" }}>({getWarehouseAbbr(item.Product[0].Warehouse_name)})</span>}</td>
              )}

              <td>{formatter.format(item.price - item.spec_discount)}</td>
              <td style={{ textAlign: "center", margin: "auto" }}>
                {item.quantity}
              </td>
              <td style={{ textAlign: "center", margin: "auto" }}>
                {formatter.format((item.price - item.spec_discount) * item.quantity)}
              </td>
            </tr>
          </>
        );
      });
    }
  };

  const renderblanktables = () => {
    if (loading) {
      return "";
    } else {
      let indexcount = 0;
      return Array.apply(null, Array(count.current)).map(() => {
        indexcount = indexcount + 1;
        return (
          <tr>
            <td>{serialcount.current + indexcount}</td>
            {/* <td></td> */}
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        );
      });
    }
  };

  const renderVisibleContent = () => (
    <div>
      <div style={{ padding: "10px" }}>
        <Row
          // className="invoice_print_fontSize"
          style={{
            // borderBottom: "2px solid lightgray",
            marginTop: "10px",
            paddingBottom: "5px",
          }}
        >
          <Col span={24} style={{ textAlign: "center" }}>
            {renderImage()}
            {/* <b>{branch.CompanyName}</b> */}
            {/* <br></br>
            {branch.name}
            <br></br>
            {branch.address}
            {console.log(branch)} */}
          </Col>
          <Col span={24}>
            MUSHAK 6.3<br></br>
            {/* {details.Location_name === "Ecommerce" ? (
              <>
                PURCHASE FROM: <b style={{ color: "red" }}>E-COMMERCE</b>
                <br></br>
              </>
            ) : (
              ""
            )} */}
            PURCHASE FROM: <b style={{ color: "red" }}>{displayLocationName}</b><br></br>
            INVOICE N0.{" "}
            {details.invoice_number ? (
              <b>{details.invoice_number}</b>
            ) : (
              ""
            )}{" "}
            {/*<br></br> ORDER NO.{" "}
            {details.order_number ? <b>{details.order_number}</b> : ""} */}
            <br></br>
            {branch.contact ? (
              <>
                CALL/CONTACT : <b>{branch.contact}</b> <br></br>
              </>
            ) : (
              ""
            )}
            {details.issue_date ? (
              <>
                ISSUE DATE : {details.issue_date}
                <br></br>
              </>
            ) : (
              ""
            )}
            {details.delivery_date ? (
              <>
                DELIVERY DATE : {details.delivery_date}
                <br></br>
              </>
            ) : (
              ""
            )}
            {details.program_date ? (
              <>PROGRAM DATE : {details.program_date}</>
            ) : (
              ""
            )}
          </Col>
          {details.contact ? (
            <>
              <Row>
                <Col span={24} style={{ textAlign: "left" }}>
                  <Row>
                    <Col span={24}>
                      {details.Contact[0].name ? (
                        <>{(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") ? "SHIPPING" : "CUSTOMER"} NAME : {details.Contact[0].name}</>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col span={24}>
                      {details.Contact[0].phone ? (
                        <>{(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") ? "SHIPPING" : "CUSTOMER"} PHONE : {details.Contact[0].phone}</>
                      ) : (
                        ""
                      )}
                    </Col>
                    <Col span={24}>
                      {details.Contact[0].address ? (
                        <>{(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") ? "SHIPPING" : "CUSTOMER"} ADDRESS : {details.Contact[0].address}</>
                      ) : (
                        ""
                      )}
                    </Col>
                    {(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") && (
                      <Col span={24}>
                        {details.invoice_by ? (
                          <>INVOICE BY : {details.invoice_by}</>
                        ) : (
                          ""
                        )}
                      </Col>
                    )}
                  </Row>
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}
        </Row>
        <br></br>
        <Row>
          <Col span={24}>
            <table className="product_table ">
              <tbody>
                <tr style={{ fontWeight: "500" }}>
                  <td>SL</td>
                  <td>PRODUCT DETAILS</td>
                  {/* <td>DESIGN CODE</td> */}
                  <td>RATE</td>
                  <td>QTY</td>
                  <td>AMOUNT</td>
                </tr>
                {renderitems()}
                {/* {renderservices()} */}
                {/* {renderblanktables()} */}
              </tbody>
            </table>
            <Row>
              <Col className="invoice_print_fontSize"
                span={8}
                style={{ textAlign: "left", marginTop: "20px" }}
              >
                {/* <div style={{ fontSize: "20px" }} >Method: </div>
                <div style={{ fontSize: "20px", fontWeight: "600" }} >{details.Payment_method}</div> */}

                {details.remarks ? (
                  <>
                    <Row>
                      <div className="d-div-invoice"
                        style={{
                          // color: '#333',
                          fontWeight: '800',
                          fontSize: '20px',
                          color: 'red',
                          // lineHeight: '1.5',
                          // padding: '10px'
                        }}
                        dangerouslySetInnerHTML={{ __html: details.remarks, }}
                      >
                      </div>
                    </Row>
                  </>
                ) : (
                  ""
                )}
              </Col>
              <Col
                span={16}
                style={{
                  textAlign: "right",
                  marginTop: "5px",
                }}
              >
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <tbody>
                    {details.delivery_charge > 0 && (
                      <tr>
                        <td style={{ textAlign: "right", padding: "2px 5px" }}>DELIVERY CHARGE(+)</td>
                        <td style={{ textAlign: "right", padding: "2px 5px", width: "100px" }}>
                          <span className="order_span_bill">
                            {formatter.format(details.delivery_charge)}
                          </span>
                        </td>
                      </tr>
                    )}

                    {details.discount > 0 && (
                      <tr>
                        <td style={{ textAlign: "right", padding: "2px 5px" }}>DISCOUNT(-)</td>
                        <td style={{ textAlign: "right", padding: "2px 5px", width: "100px" }}>
                          <span className="order_span_bill">
                            {formatter.format(details.discount)}
                          </span>
                        </td>
                      </tr>
                    )}

                    <tr>
                      <td style={{ textAlign: "right", padding: "2px 5px" }}>TOTAL AMOUNT</td>
                      <td style={{ textAlign: "right", padding: "2px 5px", width: "100px" }}>
                        <span className="order_span_bill">
                          {formatter.format(details.bill)}
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ textAlign: "right", padding: "2px 5px" }}>TOTAL PAYMENT</td>
                      <td style={{ textAlign: "right", padding: "2px 5px", width: "100px" }}>
                        <span className="order_span_bill">
                          {formatter.format(details.payment)}
                        </span>
                      </td>
                    </tr>

                    <tr>
                      <td style={{ textAlign: "right", padding: "2px 5px" }}>BALANCE DUE</td>
                      <td style={{ textAlign: "right", padding: "2px 5px", width: "100px" }}>
                        <span className="order_span_bill">
                          {formatter.format(details.due)}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );

  if (inline) {
    return renderVisibleContent();
  }

  return (
    <>
      <>
        {buttonType === "button" ? (
          <Button type="primary" disabled={disabled} onClick={showDrawer} block style={{ marginTop: 16 }}>
            {buttonText || "Print"}
          </Button>
        ) : (
          <a href="#" onClick={(e) => { e.preventDefault(); showDrawer(); }} style={{ margin: 4 }}>
            Invoice
          </a>
        )}
        <Drawer
          width="40%"
          onClose={onClose}
          visible={visible}
          placement="right"
          bodyStyle={{ margin: 0 }}
        >
          <ReactToPrint
            trigger={() => <button>Print this out!</button>}
            content={() => componentRef.current}
            onAfterPrint={() => {
              setVisible(false);
              if (onAfterPrint) onAfterPrint();
            }}
          />
          <div style={{ display: "none" }}>
            <div ref={componentRef} style={{ padding: "10px" }}>
              <Row
                className="invoice_print_fontSize"
                style={{
                  // borderBottom: "2px solid lightgray",
                  marginTop: "2px",

                  paddingBottom: "2px",
                }}
              >
                <Col span={24} style={{ textAlign: "center" }} >
                  {/* {renderImage()} */}
                  {(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") ? (
                    <Row>
                      <Col span={8} style={{ textAlign: "left" }}>
                        <div style={{
                          // transform: "scale(1.5)", 
                          transformOrigin: "right",
                          width: "fit-content",
                          height: "fit-content",
                          position: "absolute",
                          // left: "0px",
                          top: "100%",
                          right: "30px",
                          transform: "scale(1) translateY(-50%)"
                        }}>
                          {renderImage()}
                        </div>
                      </Col>
                      <Col span={8} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <div style={{ fontWeight: "800", fontSize: "44px", letterSpacing: "5px", fontFamily: '"Times New Roman", Times, serif', }}>
                          SHIRTEX
                        </div>
                      </Col>
                      <Col span={8}>

                      </Col>
                    </Row>
                  ) : (
                    renderImage()
                  )}
                  <div
                    className="d-div"
                    dangerouslySetInnerHTML={{
                      __html: businessprofile.address,
                    }}
                  >

                  </div>
                  <div className="d-div"
                    dangerouslySetInnerHTML={{ __html: businessprofile.social_link, }}
                  >
                  </div>
                  <div className="d-div"
                    dangerouslySetInnerHTML={{ __html: businessprofile.website_link, }}
                  >
                  </div>
                  {/* {branch.contact ? (
                    <>
                      Showroom: <>{branch.contact}</> 
                    </>
                  ) : (
                    ""
                  )} */}
                  {/* <b>{branch.CompanyName}</b> */}
                  {/* <br></br>
                  {branch.name}
                  <br></br>
                  {branch.address}
                  {console.log(branch)} */}
                  <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginBottom: "5px" }}></div>
                </Col>

                <Col span={24} style={{ marginTop: "10px" }}>
                  {/* MUSHAK 6.3<br></br> */}
                  {/* {details
                  .Location_name === "Ecommerce" ? (
                    <>
                      PURCHASE FROM: <b style={{ color: "red" }}>E-COMMERCE</b>
                      <br></br>
                    </>
                  ) : (
                    ""
                  )} */}
                  PURCHASE FROM: <b style={{ color: "red" }}>{displayLocationName}</b><br></br>
                  INVOICE N0.{" "}
                  {details.invoice_number ? (
                    <b>{details.invoice_number}</b>
                  ) : (
                    ""
                  )}{" "}
                  {/*<br></br> ORDER NO.{" "}
                  {details.order_number ? <b>{details.order_number}</b> : ""} */}
                  <br></br>
                  {branch.contact ? (
                    <>
                      CALL/CONTACT : <b>{branch.contact}</b> <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  {details.issue_date ? (
                    <>
                      {/* ISSUE DATE : {details.issue_date} */}
                      ISSUE DATE : {formattedCreatedDate}
                      <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  {details.delivery_date ? (
                    <>
                      DELIVERY DATE : {details.delivery_date}
                      <br></br>
                    </>
                  ) : (
                    ""
                  )}
                  {details.program_date ? (
                    <>PROGRAM DATE : {details.program_date}</>
                  ) : (
                    ""
                  )}
                </Col>
                {details.contact ? (
                  <>
                    <Row>
                      <Col span={24} style={{ textAlign: "left" }}>
                        <Row>
                          <Col span={24}>
                            {details.Contact[0].name ? (
                              <>{(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") ? "SHIPPING" : "CUSTOMER"} NAME : {details.Contact[0].name}</>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col span={24}>
                            {details.Contact[0].phone ? (
                              <>{(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") ? "SHIPPING" : "CUSTOMER"} PHONE : {details.Contact[0].phone}</>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col span={24}>
                            {details.Contact[0].address ? (
                              <>{(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") ? "SHIPPING" : "CUSTOMER"} ADDRESS : {details.Contact[0].address}</>
                            ) : (
                              ""
                            )}
                          </Col>
                          {(details.Location_name === "Ecommerce" || details.Location_name === "Main Warehouse") && (
                            <Col span={24}>
                              {details.invoice_by ? (
                                <>INVOICE BY : {details.invoice_by}</>
                              ) : (
                                ""
                              )}
                            </Col>
                          )}
                        </Row>
                      </Col>


                      {/* <Col span={24} style={{ textAlign: "right" }}>
                        <Row>
                          <Col span={24}>
                            {details.shipping_name ? (
                              <>SHIPPING NAME : {details.shipping_name}</>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col span={24}>
                            {details.shipping_phone ? (
                              <>SHIPPING PHONE : {details.shipping_phone}</>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col span={24}>
                            {details.shipping_address ? (
                              <>SHIPPING ADDRESS : {details.shipping_address}</>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </Col> */}
                    </Row>
                  </>
                ) : (
                  <></>
                )}
              </Row>
              <br></br>
              <Row>
                <Col span={24}>
                  <table className="product_table invoice_print_fontSize">
                    <tbody>
                      <tr style={{ fontWeight: "600", border: "2px" }}>
                        <td>SL</td>
                        <td>Details</td>
                        {/* <td>DESIGN CODE</td> */}
                        <td>MRP</td>
                        <td>Qty</td>
                        <td>Total</td>
                      </tr>
                      {renderitems()}
                      {/* {renderservices()} */}
                      {/* {renderblanktables()} */}
                    </tbody>
                  </table>
                  <Row>
                    <Col className="invoice_print_fontSize"
                      span={8}
                      style={{ textAlign: "left", marginTop: "20px" }}
                    >
                      {/* <div style={{ fontSize: "20px" }} >Method: </div>
                      <div style={{ fontSize: "20px", fontWeight: "600" }} >{details.Payment_method}</div> */}

                      {details.remarks ? (
                        <>
                          <Row>
                            <div className="d-div-invoice"
                              style={{
                                // color: '#333',
                                fontWeight: '800',
                                fontSize: '20px',
                                color: 'red',
                                // lineHeight: '1.5',
                                // padding: '10px'
                              }}
                              dangerouslySetInnerHTML={{ __html: details.remarks, }}
                            >
                            </div>
                          </Row>
                        </>
                      ) : (
                        ""
                      )}


                    </Col>
                    <Col
                      span={16}
                      className="product_table invoice_print_fontSize"
                      style={{
                        textAlign: "right",
                        marginTop: "20px",
                      }}
                    >
                      {/* {details.tax > 0 ? (
                        <>
                          <Row>
                            <Col span={18} style={{ margin: "auto" }}>
                              VAT (Inclusive)
                            </Col>
                            <Col span={5} offset={1}>
                              <span className="order_span_bill ">
                                {formatter.format(details.tax)}
                              </span>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        ""
                      )} */}
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <tbody>
                          {details.delivery_charge > 0 && (
                            <tr>
                              <td style={{ textAlign: "right", padding: "2px 5px" }}>DELIVERY CHARGE(+)</td>
                              <td style={{ textAlign: "right", padding: "2px 5px", width: "120px" }}>
                                <span className="order_span_bill">
                                  {formatter.format(details.delivery_charge)}
                                </span>
                              </td>
                            </tr>
                          )}

                          {details.discount > 0 && (
                            <tr>
                              <td style={{ textAlign: "right", padding: "2px 5px" }}>DISCOUNT(-)</td>
                              <td style={{ textAlign: "right", padding: "2px 5px", width: "120px" }}>
                                <span className="order_span_bill">
                                  {formatter.format(details.discount)}
                                </span>
                              </td>
                            </tr>
                          )}

                          <tr>
                            <td style={{ textAlign: "right", padding: "2px 5px" }}>TOTAL AMOUNT</td>
                            <td style={{ textAlign: "right", padding: "2px 5px", width: "120px" }}>
                              <span className="order_span_bill">
                                {formatter.format(details.bill)}
                              </span>
                            </td>
                          </tr>

                          <tr>
                            <td style={{ textAlign: "right", padding: "2px 5px" }}>TOTAL PAYMENT</td>
                            <td style={{ textAlign: "right", padding: "2px 5px", width: "120px" }}>
                              <span className="order_span_bill">
                                {formatter.format(details.payment)}
                              </span>
                            </td>
                          </tr>

                          <tr>
                            <td style={{ textAlign: "right", padding: "2px 5px" }}>BALANCE DUE</td>
                            <td style={{ textAlign: "right", padding: "2px 5px", width: "120px" }}>
                              <span className="order_span_bill">
                                {formatter.format(details.due)}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </Col>
                    {/* <Col
                      span={6}
                      style={{ textAlign: "left", marginTop: "5px" }}
                    >
                      <h3
                        style={{
                          borderBottom: "2px solid gray",
                          display: "inline-block",
                        }}
                      >
                        PAYMENT METHOD
                      </h3>
                      <br></br>
                      {details.Payment_method}
                      <br></br>
                      {details.Account_no ? (
                        <>
                          <small>Account no. {details.Account_no}</small>
                        </>
                      ) : (
                        ""
                      )}
                    </Col> */}
                  </Row>
                </Col>
              </Row>
              <br></br>
              <h4 style={{ fontWeight: 'bold', fontSize: '16px', color: '#000' }}><u>TERMS & CONDITIONS:</u></h4>
              <ul style={{ listStyleType: 'none', padding: 0 }}>
                <li style={{ fontWeight: 'bold', fontSize: "15px", color: '#000' }}>1. Product can be exchanged once within 3 days in intact condition</li>
                <li style={{ fontWeight: 'bold', fontSize: "15px", color: '#000' }}>2. Under Any Circumstances, No Amount will Be Refunded</li>
                <li style={{ fontWeight: 'bold', fontSize: "15px", color: '#000' }}>3. Invoice must be brought for exchanging product</li>
              </ul>
              <br></br>
              <Row style={{ margin: "auto" }}>
                <Col span={16}><Barcode value={details.invoice_number} width={3} height={40} format="CODE128" /></Col>
                <Col span={2}></Col>
                <Col span={2}></Col>
              </Row>
              <div style={{ borderWidth: 2, borderStyle: 'solid', borderColor: '#303338', marginBottom: "5px" }}></div>

              <div style={{ fontWeight: '700', fontSize: "14px", marginTop: "10px", }}>Powered by: THE ICT HUB</div>
              {/* <br></br> */}
              <div style={{ fontWeight: '700', fontSize: "14px", marginBottom: "10px" }}>Visit: https://theicthub.com</div>

            </div>
          </div>
          {renderVisibleContent()}
        </Drawer>
      </>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getInvoiceItem,
  getServices,
  getBusinessProfile,
  getInvoiceMeasurement,
  getSpecificLocation,
  getSpecificInvoice,
})(Quickview);
